module.exports = __webpack_public_path__ + "static/media/tisse.9989edba.m4a";